

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"34","height":"28"}, rest), [h('g', {"fill":"#FFF","fill-rule":"evenodd"}, [h('path', {"d":"m16.284 9.293-5.657 5.657a1 1 0 1 0 1.414 1.414l3.957-3.957L16 26.071a1 1 0 0 0 2 0v-13.65l3.944 3.943a1 1 0 0 0 1.32.083l.094-.083a1 1 0 0 0 0-1.414l-5.657-5.657a.996.996 0 0 0-.648-.291h-.121a.996.996 0 0 0-.648.29Z"}, []), h('path', {"fill-rule":"nonzero","d":"M6 22v-.07A7.002 7.002 0 0 1 7.2 8.002C8.126 3.437 12.162 0 17 0s8.875 3.437 9.8 8.003L27 8a7 7 0 0 1 0 14h-4a1 1 0 0 1 0-2h4a5 5 0 0 0 4.995-4.783L32 15c0-2.761-2.239-5-4.97-5l-.2.003-1.66.025-.33-1.628a8.003 8.003 0 0 0-15.68 0l-.333 1.65-1.683-.048a5 5 0 0 0-.861 9.947L6.64 20H11a1 1 0 0 1 0 2H6Z"}, [])])]);
};

        